/**
 * text separate with "," map to array
 */
const mapToArray = (text: string) => {
    if (text === undefined) {
        return [];
    }
    return text.split(",");
};

export default mapToArray;
